import { WrapApolloProvider, DataTransportContext, createTransportedQueryPreloader, isTransportedQueryRef, reviveTransportedQueryRef, ApolloClient as ApolloClient$1, InMemoryCache as InMemoryCache$1 } from '@apollo/client-react-streaming';
import { registerLateInitializingQueue } from '@apollo/client-react-streaming/manual-transport';
import React2, { useMemo, useId, useRef } from 'react';
import jsesc from 'jsesc';
import { createQueryPreloader } from '@apollo/client/react/index.js';

// src/routerWithApolloClient.tsx

// src/bundleInfo.ts
var bundle = {
  pkg: "@apollo/client-integration-tanstack-start",
  client: "ApolloClient",
  cache: "InMemoryCache"
};
var APOLLO_HOOK_PREFIX = "@@apollo.hook/";
var ApolloProvider = ({
  router,
  children
}) => {
  return /* @__PURE__ */ React2.createElement(
    WrappedApolloProvider,
    {
      router,
      makeClient: () => router.options.context.apolloClient
    },
    children
  );
};
var WrappedApolloProvider = WrapApolloProvider(
  (props) => {
    const router = props.router;
    const { onQueryEvent } = props;
    if (router.serverSsr) {
      const ssr = router.serverSsr;
      props.registerDispatchRequestStarted(({ event, observable }) => {
        ssr.injectHtml(
          () => new Promise((resolve) => {
            ensureInitialized(router);
            function transportEvent(event2) {
              const script = `__APOLLO_EVENTS__.push(${jsesc(event2, {
                isScriptContext: true,
                wrap: true,
                json: true
              })})`;
              ssr.injectScript(() => script);
            }
            transportEvent(event);
            observable.subscribe({
              next(event2) {
                transportEvent(event2);
              },
              complete() {
                resolve("");
              },
              error() {
                resolve("");
              }
            });
          })
        );
      });
    } else {
      if (onQueryEvent) {
        registerLateInitializingQueue("__APOLLO_EVENTS__", onQueryEvent);
      }
    }
    const dataTransport = useMemo(
      () => ({
        useStaticValueRef(value) {
          const key = APOLLO_HOOK_PREFIX + useId();
          const streamedValue = router.clientSsr?.getStreamedValue(key);
          const dataValue = router.clientSsr && streamedValue !== undefined ? streamedValue : value;
          const dataRef = useRef(dataValue);
          if (router.serverSsr) {
            if (!router.serverSsr.streamedKeys.has(key)) {
              router.serverSsr.streamValue(key, value);
            }
          }
          return dataRef;
        }
      }),
      [router]
    );
    return /* @__PURE__ */ React2.createElement(DataTransportContext.Provider, { value: dataTransport }, props.children);
  }
);
WrappedApolloProvider.info = bundle;
var streamedInit = /* @__PURE__ */ new WeakSet();
function ensureInitialized(router) {
  const ssr = router.serverSsr;
  if (ssr && !streamedInit.has(router)) {
    streamedInit.add(router);
    ssr.injectScript(() => `window.__APOLLO_EVENTS__||=[]`);
  }
}
function routerWithApolloClient(router, apolloClient) {
  const context = router.options.context;
  context.apolloClient = apolloClient;
  context.preloadQuery = router.isServer ? createTransportedQueryPreloader(
    apolloClient
  ) : createQueryPreloader(apolloClient);
  const originalHydrate = router.options.hydrate;
  router.options.hydrate = (...args) => {
    originalHydrate?.(...args);
    for (const match of router.state.matches) {
      JSON.stringify(match.loaderData, (_, value) => {
        if (isTransportedQueryRef(value)) {
          reviveTransportedQueryRef(
            value,
            router.options.context.apolloClient
          );
        }
        return value;
      });
    }
  };
  const PreviousInnerWrap = router.options.InnerWrap || React2.Fragment;
  router.options.InnerWrap = ({ children }) => /* @__PURE__ */ React2.createElement(ApolloProvider, { router }, /* @__PURE__ */ React2.createElement(PreviousInnerWrap, null, children));
  return router;
}
var ApolloClient = class extends ApolloClient$1 {
  /**
   * Information about the current package and it's export names, for use in error messages.
   *
   * @internal
   */
  static info = bundle;
};
var InMemoryCache = class extends InMemoryCache$1 {
  /**
   * Information about the current package and it's export names, for use in error messages.
   *
   * @internal
   */
  static info = bundle;
};
const built_for_browser = true;

export { ApolloClient, InMemoryCache, built_for_browser, routerWithApolloClient };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.js.map